<template>
  <div class="stepModal position-relative add-cf-user-modal">
    <div class="modal fade" id="inviteUserModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              Add User
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label for="">Email</label>
                <input type="email" required class="form-control" placeholder="Enter Email" v-model="email">
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-sm btn-primary pull-right" @click="addMember" :disabled="loading" type="submit" >Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import swal from "sweetalert2";

export default {
  name: "inviteUser",
  data(){
    return {
      loading: false,
      email: '',
      selectedAccount: {}
    }
  },
  methods: {
    load(account) {
      this.selectedAccount=account
      $('#inviteUserModal').modal('show')
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".add-cf-user-modal");
      });
    },
    async addMember(){
      try{
        this.loading= true
        let resp = await this.$http.post('tenant/add-member',{
          grant_type:'token',
          accountId: this.selectedAccount.id,
          email: this.email
        });

        console.log(resp)
        this.$parent.getAllMembers()
        swal({
          title: "Success!",
          text: "You have successfully added member.",
          type: "success"
        })
        $('#inviteUserModal').modal('hide')
      }catch (e) {
        console.log('Error from adding member to account' + e.toString())
        swal({
          title: "Error!",
          text: "Something went wrong while adding member",
          type: "error"
        })
      } finally {
        this.loading=false
      }
    }

  }
}
</script>

<style scoped>

</style>